import { render, staticRenderFns } from "./user_information.vue?vue&type=template&id=5f4f9d72&scoped=true&"
import script from "./user_information.vue?vue&type=script&lang=js&"
export * from "./user_information.vue?vue&type=script&lang=js&"
import style0 from "./user_information.vue?vue&type=style&index=0&id=5f4f9d72&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5f4f9d72",
  null
  
)

export default component.exports